
import CoverGenerator from '@/components/CoverGenerator';
import Header from '@/components/Header';

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-red-50">
      <Header />
      <div className="container mx-auto px-4 py-6">
        <CoverGenerator />
      </div>
    </div>
  );
};

export default Index;
